import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResultWithMetadata, IRequestForInsuranceAllowance, IRfiaQueryMetadata, IRfiasQueryParams } from 'gen/ApiClient';
import React from 'react';

export const RfiasQueryContext = React.createContext<
	IQueryContext<IQueryResultWithMetadata<IRequestForInsuranceAllowance, IRfiaQueryMetadata>, IRfiasQueryParams>
>(undefined as any);
